import React, { ReactNode } from 'react';
import GlobalModal from './modal';
import { ButtonComponent, ButtonStyling } from '../form/elements/button';
import css from './modal.module.css';

export default function InfoModal({
  content,
  title,
  buttonText,
  onClose,
}: {
  content: string | ReactNode;
  title?: string;
  buttonText?: string;
  onClose: () => void;
}) {
  const body = (
    <>
      {title && <h1 className={css['title']}>{title}</h1>}
      {content && <div className={css['message']}>{content}</div>}
    </>
  );

  return (
    <GlobalModal
      visible={true}
      body={body}
      onClose={onClose}
      buttons={[
        <ButtonComponent
          key={'ok'}
          name={'ok'}
          styling={ButtonStyling.primary}
          label={buttonText ?? 'Ok'}
          click={onClose}
        />,
      ]}
      shouldCloseOnOverlayClick={true}
    />
  );
}
